module.exports = __webpack_public_path__ + "static/media/cinema.ef5f1456.svg";